import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Une seule étape : identifiant + mot de passe → jeton longue durée.
// Le PIN de session a été retiré le 23/09/2026 : un code partagé par toute
// l'équipe ne protégeait personne, et il était impossible de le retirer à
// quelqu'un qui s'en va. Les droits tiennent désormais au rôle du compte.

export default function ProLogin() {
  const navigate = useNavigate();
  const existingToken = localStorage.getItem('pro_token');
  useEffect(() => {
    if (existingToken) navigate('/pro', { replace: true });
  }, [existingToken, navigate]);

  // Login state
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);


  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/pro/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erreur de connexion');
      localStorage.setItem('pro_token', data.token);
      localStorage.setItem('pro_user', data.user?.identifiant || username);
      localStorage.setItem('pro_role', data.user?.role || 'conducteur');
      navigate('/pro', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl p-10 w-full max-w-sm shadow-2xl">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 bg-orange-600 rounded-xl flex items-center justify-center font-black text-white text-lg">A</div>
          <div>
            <div className="font-black tracking-wider text-lg leading-none text-slate-900">APEX PRO</div>
            <div className="text-xs text-slate-400 tracking-widest uppercase">Espace chantier</div>
          </div>
        </div>

          <form onSubmit={handleLogin}>
            <label htmlFor="username" className="block text-sm font-semibold text-slate-700 mb-2">Identifiant</label>
            <input
              id="username"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => { setUsername(e.target.value); setError(''); }}
              placeholder="prénom ou adresse e-mail"
              className="w-full px-4 py-3 border-2 border-slate-200 rounded-xl text-sm focus:border-orange-500 outline-none mb-4"
              autoFocus
            />

            <label htmlFor="password" className="block text-sm font-semibold text-slate-700 mb-2">Mot de passe</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(''); }}
              placeholder="••••••••"
              className="w-full px-4 py-3 border-2 border-slate-200 rounded-xl text-sm focus:border-orange-500 outline-none mb-2"
            />

            {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="w-full mt-4 bg-orange-600 hover:bg-orange-700 disabled:bg-orange-400 text-white font-bold py-4 rounded-xl text-lg transition-colors"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
      </div>
    </div>
  );
}
